import React from "react";

import AlertIcon from "./AlertIcon";
import ArrowIcon from "./ArrowIcon";
import BeakersIcon from "./BeakersIcon";
import BinFillHighIcon from "./BinFillIcons/BinFillHighIcon";
import BinFillLowIcon from "./BinFillIcons/BinFillLowIcon";
import BinFillMediumIcon from "./BinFillIcons/BinFillMediumIcon";
import BinIcon from "./BinIcon";
import CaretUpIcon from "./CaretUpIcon";
import CheckCircleIcon from "./CheckCircle";
import CheckmarkIcon from "./CheckmarkIcon";
import ChevronIcon from "./ChevronIcon";
import ClockIcon from "./ClockIcon";
import CloseIcon from "./CloseIcon";
import CopyIcon from "./CopyIcon";
import DocumentIcon from "./DocumentIcon";
import DollarSignIcon from "./DollarSignIcon";
import EditIcon from "./EditIcon";
import ExternalLinkIcon from "./ExternalLinkIcon";
import FileIcon from "./FileIcon";
import FilterIcon from "./FilterIcon";
import FlagIcon from "./FlagIcon";
import FolderMinusIcon from "./FolderMinusIcon";
import FolderPlusIcon from "./FolderPlusIcon";
import HelpIcon from "./HelpIcon";
import HomeIcon from "./HomeIcon";
import InfoIcon from "./InfoIcon";
import InternationalCurrencyIcon from "./InternationalCurrencyIcon";
import LightningBoltIcon from "./LightningBoltIcon";
import LinkIcon from "./LinkIcon";
import ListIcon from "./ListIcon";
import LockIcon from "./LockIcon";
import MapPinIcon from "./MapPinIcon";
import PagingIcon from "./PagingIcon";
import ParametricIcon from "./ParametricIcon";
import PlusCircleIcon from "./PlusCircleIcon";
import ProfileIcon from "./ProfileIcon";
import RefreshIcon from "./RefreshIcon";
import SearchIcon from "./SearchIcon";
import SensorIcon from "./SensorIcon";
import SettingsIcon from "./SettingsIcon";
import ShareIcon from "./ShareIcon";
import SmallCaretIcon from "./SmallCaretIcon";
import SortIcon from "./SortIcon";
import StatusIndicatorIcon from "./StatusIndicatorIcon";
import ToolIcon from "./ToolIcon";
import TrashIcon from "./TrashIcon";

/**
 * The <Icon/> element can be used instead of directly referencing specific icons.
 * This makes it easier to "browse" icons since you don't have to know the icons name
 * you can use intellisense to find what you are looking for.
 */

export const iconIndex = {
  caret: SmallCaretIcon,
  checkmark: CheckmarkIcon,
  close: CloseIcon,
  externalLink: ExternalLinkIcon,
  home: HomeIcon,
  lightningBolt: LightningBoltIcon,
  list: ListIcon,
  search: SearchIcon,
  tool: ToolIcon,
  profile: ProfileIcon,
  settings: SettingsIcon,
  help: HelpIcon,
  chevron: ChevronIcon,
  arrow: ArrowIcon,
  alert: AlertIcon,
  info: InfoIcon,
  flag: FlagIcon,
  edit: EditIcon,
  trash: TrashIcon,
  document: DocumentIcon,
  dollarSign: DollarSignIcon,
  file: FileIcon,
  plusCircle: PlusCircleIcon,
  folderPlus: FolderPlusIcon,
  folderMinus: FolderMinusIcon,
  mapPin: MapPinIcon,
  caretUp: CaretUpIcon,
  statusIndicator: StatusIndicatorIcon,
  share: ShareIcon,
  sort: SortIcon,
  paging: PagingIcon,
  copy: CopyIcon,
  refresh: RefreshIcon,
  parametric: ParametricIcon,
  internationalCurrency: InternationalCurrencyIcon,
  bin: BinIcon,
  binFillMedium: BinFillMediumIcon,
  binFillHigh: BinFillHighIcon,
  binFillLow: BinFillLowIcon,
  sensorIcon: SensorIcon,
  link: LinkIcon,
  lock: LockIcon,
  filter: FilterIcon,
  beakers: BeakersIcon,
  checkCircle: CheckCircleIcon,
  clockIcon: ClockIcon
};

export type IconIndexKey = keyof typeof iconIndex;

type ComponentProps<T> = T extends React.FC<infer P> ? P : never;

export type NamedIconProps<N, I extends N> = {
  icon: I;
  props: ComponentProps<I>;
};

function createNamedIcon<T>(index: T) {
  return <I extends keyof T>(props: { icon: I } & ComponentProps<T[I]>) => {
    const NamedIcon = (index as any)[props.icon];
    const newProps = { ...(props as any), icon: undefined };
    return <NamedIcon {...newProps} />;
  };
}

const Icon = createNamedIcon(iconIndex);

export default Icon;
